import React, { FC } from "react";
import { Id } from "../../../types";
import { useMachine } from "@xstate/react";
import { fetchMachine } from "../../../machines/fetch";
import { useRecoilValue, useSetRecoilState } from "recoil";
import {
  activeSubscriptionIdState,
  functions_modelFunctionsState,
} from "../../../atoms";
import { Button, useToast } from "@chakra-ui/react";
import { unlinkFunctionFromModelFunction } from "../../../api/unlink-function-from-model-function";

type Props = {
  functionId: Id;
  modelFunctionId: Id;
  onSuccess: () => void;
};

export const UnlinkFunctionFromModelFunction: FC<Props> = (props) => {
  const { functionId, modelFunctionId, onSuccess } = props;

  const toast = useToast();

  const activeSubscriptionId = useRecoilValue(activeSubscriptionIdState);
  const setFunctions_modelFunctions = useSetRecoilState(
    functions_modelFunctionsState
  );

  const [state, send] = useMachine(fetchMachine, {
    services: {
      fetch: () =>
        unlinkFunctionFromModelFunction({
          functionId,
          modelFunctionId,
          subscriptionId: activeSubscriptionId as Id,
        }),
    },

    actions: {
      success: (_, event: any) => {
        setFunctions_modelFunctions(event.data.functions_modelFunctions);
        onSuccess();
        toast({
          title: "koppeling tussen functie en modelfunctie verwijderd",
          status: "success",
          isClosable: true,
        });
      },

      failure: (_, event: any) => {
        toast({
          title: "verwijderen van koppeling niet gelukt",
          description: JSON.stringify(event.data, null, 2),
          status: "error",
          isClosable: true,
        });
      },
    },
  });

  return (
    <Button
      type="submit"
      size="sm"
      isLoading={state.matches("loading")}
      onClick={() => {
        send(state.matches("failure") ? "RETRY" : "FETCH");
      }}
    >
      bevestig
    </Button>
  );
};
